import {
  Button,
  Card,
  Descriptions,
  Divider,
  Empty,
  List,
  Skeleton,
  Typography,
} from "antd";
import { ArrowRight, ChevronLeft, Minus } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import classes from "../Etablissements/Etablissements.module.css";

const generalInfoDescription = [
  {
    key: "1",
    label: "Secteur",
    children: <Skeleton.Input size="large" />,
  },
  {
    key: "2",
    label: "Sous-secteur",
    children: <Skeleton.Input size="large" />,
  },
  {
    key: "3",
    label: "Spécialité",
    children: <Skeleton.Input size="large" />,
  },
  {
    key: "4",
    label: "Date de début",
    children: <Skeleton.Input size="large" />,
  },
  {
    key: "5",
    label: "Date de fin",
    children: <Skeleton.Input size="large" />,
  },
  {
    key: "6",
    label: "Mode de formation",
    children: <Skeleton.Input size="large" />,
  },
];

const participantsDescription = [
  <Skeleton.Input key="1" style={{ width: 490 }} />,
  <Skeleton.Input key="2" style={{ width: 490 }} />,
  <Skeleton.Input key="3" style={{ width: 490 }} />,
  <Skeleton.Input key="4" style={{ width: 490 }} />,
  <Skeleton.Input key="5" style={{ width: 490 }} />,
  <Skeleton.Input key="6" style={{ width: 490 }} />,
  <Skeleton.Input key="7" style={{ width: 490 }} />,
  <Skeleton.Input key="8" style={{ width: 490 }} />,
  <Skeleton.Input key="9" style={{ width: 490 }} />,
  <Skeleton.Input key="10" style={{ width: 490 }} />,
  <Skeleton.Input key="11" style={{ width: 490 }} />,
  <Skeleton.Input key="12" style={{ width: 490 }} />,
  <Skeleton.Input key="13" style={{ width: 490 }} />,
];

const trainersDescription = [
  <Skeleton.Input key="1" style={{ width: 490 }} />,
  <Skeleton.Input key="2" style={{ width: 490 }} />,
  <Skeleton.Input key="3" style={{ width: 490 }} />,
  <Skeleton.Input key="4" style={{ width: 490 }} />,
  <Skeleton.Input key="5" style={{ width: 490 }} />,
];

const homologuationInfoDescription = [
  {
    key: "1",
    label: "Dénomination Fr - Ar",
    span: 3,
    children: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        <Skeleton.Input size="large" /> <Minus />
        <Skeleton.Input size="large" />
      </div>
    ),
  },
  {
    key: "2",
    label: "Niveau",
    children: <Skeleton.Input size="large" />,
  },
  {
    key: "3",
    label: "Date limite d'homologation",
    children: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        <Skeleton.Input size="large" /> <ArrowRight />{" "}
        <Skeleton.Input size="large" />
      </div>
    ),
  },
];

const modulesList = [
  <Skeleton.Input key="1" style={{ width: 590 }} />,
  <Skeleton.Input key="1" style={{ width: 590 }} />,
  <Skeleton.Input key="1" style={{ width: 590 }} />,
  <Skeleton.Input key="1" style={{ width: 590 }} />,
];

const CoursSessionDetails = () => {
  const navigate = useNavigate();

  const { id } = useParams();

  return (
    <Card
      className={classes.listeCard}
      bordered={false}
      title={
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <Button
              size="small"
              style={{ padding: "0px" }}
              htmlType="button"
              type="text"
              onClick={() => navigate(-1)}
            >
              <ChevronLeft />
            </Button>
            <h3>Détail de la formation `{id}`</h3>
          </div>
        </div>
      }
    >
      <Divider orientation="left">Informations générales</Divider>
      <Descriptions bordered items={generalInfoDescription} />
      <Divider orientation="left">Informations de l'homologuation</Divider>
      <Descriptions bordered items={homologuationInfoDescription} />
      <br />
      <List
        header="Modules"
        bordered
        dataSource={modulesList}
        renderItem={(item) => (
          <List.Item
            style={{ display: "flex", alignItems: "center", width: "100%" }}
          >
            {item}
            <Typography.Text mark>[Consulter]</Typography.Text>
          </List.Item>
        )}
      />
      <Divider orientation="left">Formateurs</Divider>
      <List
        bordered
        dataSource={trainersDescription}
        renderItem={(item) => (
          <List.Item
            style={{ display: "flex", alignItems: "center", width: "100%" }}
          >
            {item}
            <Typography.Text mark>
              [Opérationnel / Non Opérationnel]
            </Typography.Text>
          </List.Item>
        )}
      />
      <Divider orientation="left">Participants</Divider>
      <List
        bordered
        dataSource={participantsDescription}
        renderItem={(item) => (
          <List.Item
            style={{ display: "flex", alignItems: "center", width: "100%" }}
          >
            {item}
            <Typography.Text mark>
              [En cours de formation / Diplomé]
            </Typography.Text>
          </List.Item>
        )}
      />
      <Divider orientation="left">Autres (en cours de developement)</Divider>
      <Empty description="En cours de developement" />
    </Card>
  );
};

export default CoursSessionDetails;
